import React, { FC, memo } from "react";
import { createUseStyles } from "react-jss";

import ArrowNext from "Assets/images/nextArrow.svg";
import { areEqualShallow } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  onClick: (e: any) => void;
  className?: string;
}
const NextArrow: FC<Props> = memo(({ onClick, className = "" }: Props) => {
  const classes = createUseStyles(styles)();
  const click = (e: any) => {
    e.preventDefault();
    if (onClick) onClick(e);
  };

  return (
    <ArrowNext
      id="arrowNextIcon"
      className={`${classes.pointer} ${className}`}
      onClick={click}
    />
  );
}, areEqualShallow);
NextArrow.defaultProps = {
  className: undefined,
};
export default NextArrow;
